// Conversion between a song's verses and the plain-text format the editor and the API's
// AddGuitarSong/UpdateGuitarSong endpoints use: "[Header]" lines start a verse and blank
// lines separate verses (see SongTextParser on the server).

/** Turns verses back into editable text; chords stay inline as "[G]". */
export function versesToText(verses) {
  return (verses || [])
    .map((verse) => {
      const header = (verse.Header || "").trim();
      const lines = (verse.Lines || "").replace(/\r\n/g, "\n").replace(/\n+$/, "");
      if (!header) return lines;
      return lines ? `[${header}]\n${lines}` : `[${header}]`;
    })
    .filter((block) => block.length > 0)
    .join("\n\n");
}

/** Keys the editor offers; chords are stored in the key they were written in. */
export const KEYS = [
  "C", "C#", "Db", "D", "Eb", "E", "F", "F#", "Gb", "G", "Ab", "A", "Bb", "B",
  "Cm", "C#m", "Dm", "Ebm", "Em", "Fm", "F#m", "Gm", "G#m", "Am", "Bbm", "Bm",
];
